<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <!--<div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.CALCULADORA"
                id="CALCULADORA">
                <label class="custom-control-label" for="CALCULADORA">Mostrar calculadora</label>
              </div>-->
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.SIMPLIFICAR_RESULTADO"
                id="SIMPLIFICAR_RESULTADO">
                <label class="custom-control-label" for="SIMPLIFICAR_RESULTADO">Simplificar resultado</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.REDONDEAR"
                id="REDONDEAR">
                <label class="custom-control-label" for="REDONDEAR">Redondear</label>
              </div>
          </div>
            <div class="col-md-4">
              <br/>
                Máximo decimales
                <b-form-input v-model="configuration.MAX_DECIMALES" type="number">
                </b-form-input>
            </div>
            <div class="col-md-4">
              <br/>
              Tipo aproximación<select class="form-control" v-model="configuration.APROXIMAR">
                <option value="0">Sin aproximación</option>
                <option value="1">Aproximación resultado</option>
                <option value="2">Aproximación operandos</option>
              </select>
              <div v-if="parseInt(configuration.APROXIMAR) !== 0">
                <br/>
                Nivel de aproximación
                <select class="form-control" v-model="configuration.NIVEL_APROXIMAR">
                  <option value="-5">Cienmilésimas</option>
                  <option value="-4">Diezmilésimas</option>
                  <option value="-3">Milésimas</option>
                  <option value="-2">Centésimas</option>
                  <option value="-1">Décimas</option>
                  <option value="0">Unidad</option>
                  <option value="1">Decena</option>
                  <option value="2">Centena</option>
                  <option value="3">U.millar</option>
                  <option value="4">D.millar</option>
                  <option value="5">C.millar</option>
                  <option value="6">U.millón</option>
                  <option value="7">D.millón</option>
                  <option value="8">C.millón</option>
                </select>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="12">
                Enunciado
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].ENUNCIADOS_MULTIPLES_ID !== null && arrayEleOperation[index].ENUNCIADOS_MULTIPLES_ID !== 0"
                        @click="openResourceWithParam('statementmultiple', arrayEleOperation[index].ENUNCIADOS_MULTIPLES_ID)"/>
                    <input type="text" v-model="arrayEleOperation[index].ENUNCIADOS_MULTIPLES_TEXTO"
                      disabled class="form-control" />
                    <searchstatementmultiple class="pl-2"
                      v-bind:idModal="'mdlSearchEnunciado_'+index"
                      v-on:selected="onPlantillaProblem($event, index)">
                    </searchstatementmultiple>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchstatementmultiple from '../../statements/SearchStatementMultiple.vue';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
    searchstatementmultiple,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla PROBSIMPLES_CONF
      configuration: {
        ID: -1,
        CALCULADORA: false,
        SIMPLIFICAR_RESULTADO: true,
        MAX_DECIMALES: 2,
        REDONDEAR: true, //
        APROXIMAR: 0, // [0] Sin aproximación [1] Aproximación resultado [2] Aproximación operandos
        NIVEL_APROXIMAR: 2,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        ENUNCIADOS_MULTIPLES_ID: null,
        ENUNCIADOS_MULTIPLES_TEXTO: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('problemmultiple/getproblemmultiple', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ENUNCIADOS_MULTIPLES_ID: element.ENUNCIADOS_MULTIPLES_ID,
            ENUNCIADOS_MULTIPLES_TEXTO: element.ENUNCIADOS_MULTIPLES_TEXTO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method onPlantillaProblem
    * @description Al buscar una plantilla
    */
    onPlantillaProblem(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].ENUNCIADOS_MULTIPLES_TEXTO = itemSelected.NOMBRE;
      this.arrayEleOperation[idOperation].ENUNCIADOS_MULTIPLES_ID = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', `mdlSearchEnunciado_${idOperation}`);
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
